import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import "./styles/Chatbot.css";
import ChatIconImage from "../../assets/icons/bulle.png";
import ChatIconImage2 from "../../assets/icons/profile2.png";  
import VoiceChatApp from "../VoiceChat/VoiceChatApp";

const PANEL_WIDTH = 550; // même valeur que --cb-width dans CSS

export default function Chatbot() {
  const [open, setOpen] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const [conversationHistory, setConversationHistory] = useState([]); // Persisted state

  const toggle = () => setOpen((o) => !o);

  useEffect(() => {
    document.body.classList.toggle("chatbot-open", open);
    return () => document.body.classList.remove("chatbot-open");
  }, [open]);

  return (
    <>
      {/* Launcher */}
      {!open && (
        <motion.button
          className="cb-launcher"
          onClick={toggle}
         initial={{ scale: 1, y: 0 }}
        animate={{ scale: [1, 1.3, 1], y: [0, -5, 0] }}
          transition={{ duration: 1.5, repeat: Infinity, repeatType: "mirror" }}
        >
          <img src={ChatIconImage2} alt="Chatbot" />
        </motion.button>
      )}

      {/* Chat panel */}
      <AnimatePresence>
        {open && (
          <motion.aside
            className="cb-panel"
            initial={{ x: PANEL_WIDTH }}
            animate={{ x: 0 }}
            exit={{ x: PANEL_WIDTH }}
            transition={{ type: "tween", duration: 0.3 }}
          >
            <header className="cb-header">
              <div className="cb-title">
                <img src={ChatIconImage2} alt="" />
                <div>
                  <h3>Searchy</h3>
                  <span>Chatbot Assistant</span>
                </div>
              </div>
              <div className="cb-actions">
                <IconButton
                  onClick={() => setShowGuide((g) => !g)}
                  aria-label="Aide"
                >
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
                <IconButton onClick={toggle} aria-label="Fermer le chat">
                  <CloseOutlinedIcon fontSize="small" />
                </IconButton>
              </div>
            </header>

            <main className="cb-body">
              <VoiceChatApp
                conversationHistory={conversationHistory}
                setConversationHistory={setConversationHistory}
              />
            </main>
          </motion.aside>
        )}
      </AnimatePresence>

     {/* Guide modal */}
{showGuide && (
  <div className="guide-overlay">
    <div className="guide-modal">
      {/* Floating close button */}
      <button
        className="close-guide-btn"
        onClick={() => setShowGuide(false)}
        aria-label="Fermer le guide"
      >
        <CloseOutlinedIcon fontSize="small" />
      </button>

      {/* Header with just the title */}
      <div className="guide-header">
        <h2>Guide d'utilisation</h2>
      </div>

      <div className="guide-content">
        <p>Voici comment utiliser notre chatbot Searchy&nbsp;:</p>
        <ul>
          <li>
            <strong>Tapez votre requête</strong> puis « Envoyer »
          </li>
          <li>
            <strong>Utilisez le micro</strong> pour la voix
          </li>
          <li>
            <strong>Suggestions rapides</strong> : cliquez sur les bulles
          </li>
        </ul>
        <p>
          <strong>Les profils sont générés par l'IA.</strong>
        </p>
      </div>
    </div>
  </div>
)}

    </>
  );
}

/**
 * Simple styled button to mimic MUI IconButton
 */
function IconButton({ children, ...props }) {
  return (
    <button className="cb-icon-button" {...props}>
      {children}
    </button>
  );
}
